module.exports = __webpack_public_path__ + "static/media/Pause.0cfa7bea.svg";